import React, { Component, PropTypes } from 'react';
import { browserHistory, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { fetchPromotion } from '../actions/';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import ViewPromotion from '../components/promotions/ViewPromotion';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  promotions: PropTypes.object,
  params: PropTypes.object,
  error: PropTypes.any,
  query: PropTypes.object.isRequired,
};

class PromotionViewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertOpen: false,
      alertMessage: '',
      edited: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.push('/');
    }
  }
  componentDidMount() {
    this.props.dispatch(fetchPromotion(this.props.params.id));
  }
  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="promotion component" style={authPage}>
        <h2>View Promotion</h2>
        <div className="content">
          <ViewPromotion
            promotion={this.props.promotions.promotion}
          />
        </div>
      </div>
    );
  }
}

PromotionViewPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

PromotionViewPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    promotions: state.promotions,
    query: ownProps.location.query,
  };
}

export default withRouter(connect(mapStateToProps)(PromotionViewPage));



// WEBPACK FOOTER //
// ./src/containers/PromotionViewPage.js